import styled, { css } from "styled-components";
import { colors, fonts } from "../../../styles/variables";

export const CardContainer = styled.div<{ isIndexEven: boolean }>`
  width: 50%;
  margin-bottom: 20px;
  padding-right: ${({ isIndexEven }) => (isIndexEven ? "10px" : "0px")};
  padding-left: ${({ isIndexEven }) => (isIndexEven ? "0px" : "10px")};
`;

export const InnerCardContainer = styled.div`
  display: flex;
  width: 100%;
  flex: 1;
`;

export const CardContent = styled.div`
  display: flex;
  background-color: ${colors.white};
  flex-direction: column;
  align-items: center;
  padding: 20px 10px;
  cursor: pointer;
  width: 100%;
`;

export const PercentMatch = styled.button`
  color: ${colors.black};
  font-family: ${fonts.fontInterstateBlackCompressed};
  font-size: 18px;
  line-height: 21px;
  cursor: pointer;
  text-decoration: underline;
  margin-bottom: 10px;
`;

export const WineClassText = styled.p`
  font-size: 12px;
  line-height: 14px;
  font-family: ${fonts.fontConceptRegular};
  margin-bottom: 5px !important;
  text-align: center;
`;

export const WineNameText = styled.p<{ addBottomMargin: boolean }>`
  font-size: 20px;
  line-height: 24px;
  height: 46px;
  max-width: 100%;
  text-align: center;
  font-family: ${fonts.fontInterstateBlackCompressed};
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin-bottom: ${({ addBottomMargin }) => (addBottomMargin ? "12px" : "10px")};
`;

export const BottleImage = styled.img`
  width: auto;
  height: 171px;
`;

export const BottleTitle = styled.h3`
  font-size: 11px;
  font-family: ${fonts.fontInterstateUltraBlack};
  text-transform: uppercase;
  text-align: center;
  margin: 12px 0 5px;
`;

export const RegionText = styled.p<{ addBottomMargin: boolean }>`
  font-size: 12px;
  line-height: 15px;
  font-family: ${fonts.fontBauRegular};
  margin-bottom: ${({ addBottomMargin }) => (addBottomMargin ? "7px" : "0px")} !important;
  text-align: center;
`;

export const AddText = styled.span`
  font-family: ${fonts.fontBauMedium};
  font-size: 10px;
  text-transform: uppercase;
  color: ${colors.white};
`;

export const PriceLabel = styled.span`
  font-family: ${fonts.fontInterstateBlackCompressed};
  font-size: 18px;
  line-height: 21px;
  text-align: right;
  color: ${colors.white};
`;

export const StyledAddWineToShoppingCartButton = styled.button`
  font-family: ${fonts.fontBauMedium};
  min-height: 30px;
  display: flex;
  flex: 1;
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0px 15px;
  cursor: pointer;
  text-transform: uppercase;
  background-color: ${colors.black};
  color: ${colors.white};
  font-size: 12px;
`;

export const PastWinesOrderedDateTag = styled.p`
  color: ${colors.white};
  font-size: 10px;
  font-family: ${fonts.fontBauMedium};
  background-color: ${colors.black};
  padding: 3px 16px;
  border-radius: 10px;
  white-space: nowrap;
  text-transform: uppercase;
  margin-bottom: 12px !important;
`;

export const PastWineRatingLoadingStyle = css`
  margin: 5px 0 5px;
  height: 5px;
  width: 16px;
  position: relative;
`;

export const PastWineRatingSpinnerStyle = css`
  height: 16px;
  width: 16px;
  top: 0;
  left: 0;
`;
